/* =================== FOTOS HOME =================== */
$(function () {
  $('.carrossel-fotos').each(function () {
    // Elemento
    const $carousel = $(this);

    // Total de itens no carrossel
    const totalItens = $carousel.find('.splide__slide').length;

    // Configuração de colunas do carrossel
    const cols = {
      desktop: 4,
      tablet: 3,
      mobile: 3,
    };

    // Opções gerais do slide
    let carouselOpts = {
      type: "loop",
      gap: "20px",
      arrows: false,
      pagination: false,
      perPage: 6,
      padding: { left: '8rem', right: '8rem' },
      autoScroll: {
        speed: 1,
      },
      breakpoints: {
        // DESKTOP XL
        2300: {
          perPage: 5,
        },
        // Desktop L
        1600: {
          perPage: 4,
        },
        // Desktop
        1200: {
          perPage: cols.tablet,
        },
        // Tablet
        1200: {
          perPage: cols.tablet,
        },
        // Mobile
        760: {
          //destroy: true, // <-- Descomente para desativar o carrossel
          perPage: cols.mobile,
          autoplay: false,
          drag: 'free',
          fixedWidth: '75%', // <- Ignora o 'perPage'
          padding: { left: '20px', right: '20px' },
        },
      },
    };

    // Ajuste para quando houver menos itens do que a quantidade por página do carrossel (Centraliza)
    if (
      (isMedia('desktop') && totalItens < cols.desktop) ||
      (isMedia('tablet') && totalItens < cols.tablet)
    ) {
      $carousel.addClass('carousel-force-center');
      carouselOpts.type = 'slide';
      carouselOpts.arrows = false;
      carouselOpts.pagination = false;
      carouselOpts.drag = false;
      carouselOpts.autoplay = false;
      carouselOpts.keyboard = false;
    }

    // Inicia o carrossel
    let carousel = new Splide($carousel[0], carouselOpts);

    function isMobileCarousel() {
      return window.innerWidth <= 760;
    }

      carousel.mount(window.splide.Extensions); // apenas no mobile
  });
});
